import React from "react";
import { FormattedMessage } from "react-intl";
// fraud code, can get from there https://conduster.atlassian.net/wiki/spaces/CON/pages/187990017
const fraudCodes = {
  authenticity: {
    id: "general.fraudError.authenticity",
    default: "Lead Authenticity detected"
  },
  age: {
    id: "general.fraudError.leadAge",
    default: "Lead Age detected"
  },
  duration: {
    id: "general.fraudError.leadDuration",
    default: "Lead Duration detected"
  }
};

function _generateField(fraudMetrics) {
  let keys = Object.keys(fraudMetrics).filter(key => fraudMetrics[key]);
  return fraudMetrics ? (
    <div>
      {keys.map((metric, i) => (
        <FormattedMessage {...fraudCodes[metric]} key={i} />
      ))}
    </div>
  ) : null;
}

/**
 * Returns true when value is in fraud code
 * @param fraudMetrics{String}
 * @return {Bool}
 * @public
 */
export const isFraud = fraudMetrics => {
  return !!fraudMetrics && Object.values(fraudMetrics).some(x => !!x);
};

export const getFraudMessage = fraudMetrics =>
  isFraud(fraudMetrics) ? _generateField(fraudMetrics) : "";



// WEBPACK FOOTER //
// ./src/components/utils/isFraud.js